import { render, staticRenderFns } from "./myChallenges.vue?vue&type=template&id=681bf231&scoped=true&"
import script from "./myChallenges.vue?vue&type=script&lang=js&"
export * from "./myChallenges.vue?vue&type=script&lang=js&"
import style0 from "./myChallenges.vue?vue&type=style&index=0&id=681bf231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681bf231",
  null
  
)

export default component.exports